export default {
  setUnreadNotification: function setUnreadNotification(state, payload) {
    state.unreadNotification = payload;
  },
  setConfig: function setConfig(state, payload) {
    state.config = payload;
  }
};